import React, { useEffect, useState, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { getUserDetails } from "../../services/authService";
import FileUpload from "./imagesUpload";
import { FIND_GUEST_API } from "./config";
import languageMap from "../languageMap";
import "./UploadImages.css";
import Footer from "../Footer"; 

export default function UploadImages() {
  const loc    = useLocation();
  const params = new URLSearchParams(loc.search);

  const username  = params.get("username")  || "guest";
  const user_id   = params.get("user_id")   || "guest";
  const eventId   = params.get("event")     || "event";
  const eventName = params.get("eventName") || "אירוע";

  const [loading,  setLoading ] = useState(false);
  const [userData, setUserData] = useState(null);

  // מפתח לשמירת הסכמה פר-משתמש/אירוע
  const consentKey = useMemo(() => `heyi_consent_${user_id}_${eventId}`, [user_id, eventId]);
  const [agreed, setAgreed] = useState(() => {
    try { return localStorage.getItem(consentKey) === "1"; } catch { return false; }
  });

  /* one-time user fetch */
  useEffect(() => {
    let cancel = false;
    (async () => {
      const res = await getUserDetails(user_id);
      if (!cancel && res?.success) {
        setUserData(res.user);
        localStorage.setItem("userId", user_id);
      }
    })();
    return () => { cancel = true; };
  }, [user_id]);

  // שמירת הסכמה
  useEffect(() => {
    try {
      if (agreed) localStorage.setItem(consentKey, "1");
      else localStorage.removeItem(consentKey);
    } catch {}
  }, [agreed, consentKey]);

  const lang = languageMap.config.selectedLanguage || "en";

  return (
    <div className="upload-images-container blur-background blur-bottom blur-top">
      {/* overlay while searching images */}
      {loading && (
        <div className="loading-overlay">
          <div className="spinner" />
          <div className="loading-text">מחפש את התמונות שלך...</div>
        </div>
      )}

      {/* header */}
      <div className="logo-container-top-guest">
        <Link to="/">
          <img src="/icons/logo.png" alt="Logo" className="logo" />
        </Link>
      </div>
      <div className="top-title-guest-start">
        {`ברוכים הבאים לגלריה של ${eventName}`}
      </div>

      {/* instructions */}
      <div className="welcome-guest">
        בכדי לקבל את כל התמונות בהם הצטלמת –
        <br />
        העלה תמונת סלפי
      </div>

      {/* consent box */}
      {/* <div className="consent-box" dir="rtl" aria-live="polite">
        <label className="consent-label">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span>
            קראתי ואני מסכים/ה ל{" "}
            <Link to="/terms" className="consent-link">תקנון ותנאי שימוש</Link>
            {" "}ו{" "}
            <Link to="/privacy" className="consent-link">מדיניות פרטיות</Link>
          </span>
        </label>
        {!agreed && (
          <div className="consent-hint">
            כדי להמשיך ולהעלות תמונה יש לאשר את התנאים.
          </div>
        )}
      </div> */}

      {/* upload area */}
      <div className="bottom-section2">
        <div className={`img-upload ${!agreed ? "blocked" : ""}`}>
          {/* לייר שקוף שחוסם אינטראקציה אם אין הסכמה */}
          {!agreed && <div className="upload-blocker" aria-hidden="true" />}
          <FileUpload
            username={username}
            eventId={eventId}
            uploadRoute={`${FIND_GUEST_API}/find-guest-images`}
            onUploadStart={() => setLoading(true)}
            onUploadComplete={() => setLoading(false)}
            userData={userData}
          />
        </div>

        <Link to="/contact" className="signup-btn contact-btn button-comp">
          {languageMap.contactUs[lang]}
        </Link>
      </div>

          <Footer /> 


    </div>
  );
}
